import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=c1aac7cc&scoped=true"
import script from "./TopNav.vue?vue&type=script&lang=js"
export * from "./TopNav.vue?vue&type=script&lang=js"
import style0 from "./TopNav.vue?vue&type=style&index=0&id=c1aac7cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1aac7cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1aac7cc')) {
      api.createRecord('c1aac7cc', component.options)
    } else {
      api.reload('c1aac7cc', component.options)
    }
    module.hot.accept("./TopNav.vue?vue&type=template&id=c1aac7cc&scoped=true", function () {
      api.rerender('c1aac7cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/External/Shoplazza/components/TopNav.vue"
export default component.exports